import { IAppState } from '../../common/state';

export const getNewbuildingInformation = (state: IAppState) => {
  return state.newbuildingInformation;
};
